export default function isSharePointServiceGeneratedLink(linkUrl: string): boolean {
    return !!linkUrl && (linkUrl.indexOf('?at=') > 0 || linkUrl.indexOf('&at=') > 0);
}
